var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.2 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2 1.89a7.83 7.83 0 0 1-2.26.64A4 4 0 0 0 18.67.3a8 8 0 0 1-2.5 1A3.88 3.88 0 0 0 13.29 0a4 4 0 0 0-3.94 4 3.93 3.93 0 0 0 .11 1A11.1 11.1 0 0 1 1.34.74a4.09 4.09 0 0 0 1.22 5.39 3.87 3.87 0 0 1-1.79-.5 4 4 0 0 0 3.16 4 4 4 0 0 1-1 .14 3.64 3.64 0 0 1-.74-.07 3.94 3.94 0 0 0 3.68 2.8 7.73 7.73 0 0 1-4.93 1.74c-.32 0-.63 0-.94-.05A11 11 0 0 0 6 16c7.25 0 11.21-6.16 11.21-11.49v-.52a8.21 8.21 0 0 0 2-2.1",
    fill: "#FFFFFF",
    "data-name": "NoBox/Twitter"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitter-white.ad7ea21e7f148a1ff8343df63adbb0f5.svg";
export { ForwardRef as ReactComponent };